import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangProvider } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import MenuPage from "./pages/MenuPage";
import ChiSiamo from "./pages/ChiSiamo";
import GalleryPage from "./pages/GalleryPage";
import Prenota from "./pages/Prenota";
import Contatti from "./pages/Contatti";
import Admin from "./pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-ink min-h-screen">
      <div className="grain-overlay" />
      <BrowserRouter>
        <LangProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/menu_pizzeria_bella.pdf" element={<Navigate to="/menu" replace />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/prenota" element={<Prenota />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </LangProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121A14", border: "1px solid rgba(212,245,66,0.3)", color: "#F8FAF8" } }} />
    </div>
  );
}

export default App;
